import { Button } from '@/src/common/components/Button'
import { useEffect } from 'react'
import { ScrollView, View, Text, StyleSheet } from 'react-native'
import { Like } from '@/src/assets/icons/Like'
import { PaymentConfirmation } from '@/src/app/main/(tabs)/card/card-management/_common/paymentConfirmation'
import { CardPaymentsStore as Store } from '@/src/experiences/card-payments/store'
import { usePaymentScreen } from '@/src/experiences/card-payments/hooks/usePaymentScreen'
import { mesaColorNames, typography } from '@/src/common/theme'
import * as Surveys from '@/src/experiences/surveys'

export function useOnetimePaySuccessCardStackScreenProps() {
  return usePaymentScreen('oneTimePayment/paymentSuccessful', 'Payment Confirmation', false)
}

function OnetimePaySuccess() {
  const { clear } = Store.useOneTimePayment()

  useEffect(() => clear, [clear])

  const { Modal, dismiss } = useOnetimePaySuccessCardStackScreenProps()
  Surveys.Hooks.useScreenUnmountTrigger('card_one_time_payment_success')

  return Modal({
    children: (
      <ScrollView contentContainerStyle={{ paddingBottom: 50 }}>
        <View style={styles.centeredContainer}>
          <View style={styles.iconWrapper}>
            <Like />
          </View>
          <Text style={[typography['heading/heading4'], styles.successMessage]}>
            Payment successfully scheduled
          </Text>
        </View>
        <PaymentConfirmation />
        <Button
          title="Done"
          testID="confirm_success_and_navigate_back_to_tab_card"
          onPress={() => void dismiss()}
        />
      </ScrollView>
    ),
  })
}

const styles = StyleSheet.create({
  centeredContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 16,
  },
  iconWrapper: {
    borderRadius: 50,
    width: 56,
    height: 56,
    backgroundColor: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  successMessage: {
    color: mesaColorNames['Mesa - Brand/White #FFFFFF'],
    marginVertical: 16,
  },
})

export const OnetimePaySuccessScreen = {
  name: 'auto-pay-schedule',
  Screen: OnetimePaySuccess,
} as const
